import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import { ProjectApi } from '../../../network';
import { ProjectModel } from '../../../network/rest';
import ApiErrorHandler from '../../../utils/ApiErrorHandler';
import './style.scss';

function ProjectDetails() {
    const [data, setData] = useState<ProjectModel | undefined>();
    const { projectId } = useParams();

    useEffect(() => {
        const getData = async () => {
            try {
                if (!projectId) {
                    return;
                }
                const response = await ProjectApi.getProjectApiV1ProjectsProjectGet({
                    id: projectId,
                });
                if (response) {
                    setData(response);
                }
            } catch (e) {
                ApiErrorHandler(e, true);
            }
        };

        getData();
    }, []);

    if (data) {
        const publishedOn = new Date(data.publishOn);
        return (
            <div className="ProjectDetails">
                {data.fileUrl && <img src={data.fileUrl as unknown as string} alt={data.title} />}
                <span className="author">{data.author}</span>
                <h1 className="title">{data.title}</h1>
                <span className="date">{publishedOn.toLocaleDateString('sl')}</span>
                <div className="content">{data.content ? parse(data.content) : null}</div>
            </div>
        );
    }
    return null;
}

export default ProjectDetails;
